import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { QueryParamsSerializerService, SearchResult } from '@heda/core-util';
import { ActivatedRoute } from '@angular/router';
import { UserItem } from 'app/umka/user/services/user-item';
import { UserService } from 'app/umka/user/services/user.service';
import { SnomedDescription, SnomedDescriptionQueryParams } from 'app/mdm/terminology/snomed/services/snomed';
import { SnomedMdmService } from 'app/mdm/terminology/snomed/services/snomed-mdm.service';
import { HttpResponse } from '@angular/common/http';
import { MessageService } from '@heda/core-hospital-ui';
import { TranslateService } from '@ngx-translate/core';
import { LorqueService } from 'app/mdm/lib/lorque/services/lorque.service';

@Component({
  templateUrl: './snomed-translation-list.component.html',
})
export class SnomedTranslationListComponent implements OnInit {
  public decoratedDescriptions: { [key: string]: SnomedDescription[] } = {};
  public query: SnomedDescriptionQueryParams;
  public descriptions: SearchResult<SnomedDescription>;
  public defaultQueryParams: Partial<any> = {
    offset: 0,
    limit: 20,
  };

  public users: { [key: string]: UserItem } = {};
  public loading: boolean = false;
  @ViewChild('importTranslations') public importFileInput: ElementRef;

  constructor(
    private snomedMdmService: SnomedMdmService,
    private translateService: TranslateService,
    private messageService: MessageService,
    private userService: UserService,
    private lorqueService: LorqueService,
    private queryParamsSerializer: QueryParamsSerializerService,
    private route: ActivatedRoute
  ) {}

  public ngOnInit(): void {
    this.emptyFilter();
    this.queryParamsSerializer.load(this.route, SnomedDescriptionQueryParams, this.query);
    this.loadDescriptions();
    this.loadUsers();
  }

  public loadDescriptions(): void {
    this.queryParamsSerializer.store(this.route, this.query, this.defaultQueryParams);
    this.loading = true;
    this.snomedMdmService.queryDescription(this.query).subscribe(
      (resp) => {
        this.descriptions = resp;
        this.decorateData();
        this.loading = false;
      },
      (error) => {
        this.loading = false;
      }
    );
  }

  public emptyFilter(): void {
    this.query = new SnomedDescriptionQueryParams();
    Object.assign(this.query, this.defaultQueryParams);
  }

  private loadUsers(): void {
    this.userService.query({}).subscribe((u) => {
      u.data.forEach((user) => (this.users[user.userId] = user));
      this.users = Object.assign({}, this.users);
    });
  }

  private decorateData(): void {
    this.decoratedDescriptions = {};
    this.descriptions.data.forEach((description) => {
      if (this.decoratedDescriptions[description.conceptId]) {
        this.decoratedDescriptions[description.conceptId].push(description);
      } else {
        this.snomedMdmService
          .getConcept(description.conceptId)
          .subscribe((resp) => (description['snomedTranslations'] = resp.descriptions.filter((d) => d.active)));
        this.decoratedDescriptions[description.conceptId] = [description];
      }
    });
  }

  public exportTranslations(): void {
    this.snomedMdmService.exportTranslations(this.query).subscribe((process) => {
      this.lorqueService.awaitForProcessToFinish(process.id).then((status) => {
        if (status === 'failed') {
          this.lorqueService.getProcess(process.id).subscribe((p) => this.messageService.error(p.resultText));
          return;
        }
        this.snomedMdmService.getCSVFromProcess(process.id);
      });
    });
  }

  public exportToRF2(): void {
    this.snomedMdmService.exportToRF2(this.query).subscribe((process) => {
      this.lorqueService.awaitForProcessToFinish(process.id).then((status) => {
        if (status === 'failed') {
          this.lorqueService.getProcess(process.id).subscribe((p) => this.messageService.error(p.resultText));
          return;
        }
        this.snomedMdmService.getRF2FromProcess(process.id);
      });
    });
  }

  public touchImportTranslationsInput(): void {
    this.importFileInput.nativeElement.click();
  }

  public importTranslationsFromFile(event: any): void {
    const file = event.target.files[0];
    if (!!file) {
      this.snomedMdmService.importTranslations(file).subscribe(
        (e) => {
          if (e instanceof HttpResponse) {
            this.ngOnInit();
            this.messageService.success('mdm.snomed-02.success');
          }
        },
        (err) => this.messageService.error(err)
      );
    }
  }

  public formatUserSub(user: UserItem): string {
    if (!user) {
      return null;
    }
    return user?.identities.find((idn) => idn.system === 'sub').value;
  }
}
